import React from "react";
import "../features/check-in/components/ExistingCheckIn.css";

/**
 * Pure presentational component for loading skeleton
 */
const LoadingSkeleton = ({ variant = "default" }) => {
  if (variant === "initial") {
    return (
      <div className="loading-skeleton-container">
        <div className="loading-skeleton-line" />
        <div className="loading-skeleton-spacer" />
        <div className="loading-skeleton-line loading-skeleton-line-large" />
      </div>
    );
  }

  if (variant === "grid") {
    return (
      <div className="settings-container-card">
        <div className="loading-grid">
          {Array.from({ length: 2 }).map((_, i) => (
            <div key={i} className="loading-grid-item" />
          ))}
        </div>
      </div>
    );
  }

  if (variant === "column") {
    return (
      <div className="settings-container-card settings-container-card-large">
        <div className="loading-column">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="loading-column-item" />
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default LoadingSkeleton;
